import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Box, Flex, Heading, Text } from "@theme-ui/components";
import { useStaticQuery, graphql } from "gatsby";
import { colors, typography } from "../../styles/theme";
import styled from "@emotion/styled";
const EthosSection = ({ data }) => {
  const { ethosImg } = useStaticQuery(graphql`
    {
      ethosImg: file(relativePath: { eq: "garden/ethos-section.png" }) {
        childImageSharp {
          gatsbyImageData(width: 698, layout: CONSTRAINED)
        }
      }
    }
  `);

  return (
    <Flex sx={box}>
      <Flex
        sx={{
          maxWidth: ["24.69rem", "24.69rem", "44rem", "58.69rem"],
          gap: "3rem",
          flexDirection: "column",
        }}
      >
        <Flex sx={{ flexDirection: "column", gap: "1.5rem" }}>
          <Heading sx={{ ...typography.h2 }}>{data.title}</Heading>
          <Heading sx={{ ...typography.h3 }}>{data.subtitle}</Heading>
        </Flex>
        <StyledBox>
          <GatsbyImage
          className="img"
          image={getImage(ethosImg)}
          alt="ethos-img"
        />
        </StyledBox>
        <Text
          dangerouslySetInnerHTML={{ __html: data.desc }}
          sx={{
            maxWidth: "100%",
            ...typography.textMd400,
          }}
        />
      </Flex>
    </Flex>
  );
};

const box = {
  backgroundColor: colors.secondaryGreen100,
  textAlign: "center",
  py: ["4rem", "4rem", "7rem", "7rem"],
  justifyContent: "center",
  gap: "3rem",
};

const StyledBox = styled(Box)`
  .img {
    max-width: 43.67rem;
    @media (max-width: 600px) {
        max-width: 24.69rem;
      }
  }
`;

export default EthosSection;
